import React from 'react';
import { motion } from 'framer-motion';
import {Monitor, ExternalLink} from 'lucide-react';

const RemoteSupportButton: React.FC = () => {
  const handleClick = () => {
    window.open('https://113366.io/', '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.button
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={handleClick}
      className="fixed bottom-28 right-8 z-50 bg-gradient-to-r from-green-600 to-emerald-600 text-white p-4 rounded-full shadow-2xl hover:shadow-green-500/50 transition-all duration-300 group"
    >
      <div className="relative">
        <Monitor size={28} />
        <ExternalLink size={12} className="absolute -top-1 -right-1 bg-white text-green-600 rounded-full p-0.5" />
      </div>
      <div className="absolute right-full mr-4 top-1/2 transform -translate-y-1/2 bg-white text-gray-800 px-4 py-2 rounded-lg shadow-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none hidden md:block">
        원격 지원 바로가기
      </div>
    </motion.button>
  );
};

export default RemoteSupportButton;
